module.exports = __webpack_public_path__ + "img/video.27fbb3bb.png";